import { render, staticRenderFns } from "./CategoriesSlider.vue?vue&type=template&id=ca55b558&scoped=true&"
import script from "./CategoriesSlider.vue?vue&type=script&lang=js&"
export * from "./CategoriesSlider.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSlider.vue?vue&type=style&index=0&id=ca55b558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca55b558",
  null
  
)

export default component.exports